import { render, staticRenderFns } from "./consumables.vue?vue&type=template&id=0e86ff5e&scoped=true"
import script from "./consumables.vue?vue&type=script&lang=ts"
export * from "./consumables.vue?vue&type=script&lang=ts"
import style0 from "./consumables.vue?vue&type=style&index=0&id=0e86ff5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e86ff5e",
  null
  
)

export default component.exports